import { useTranslation } from '../hooks/useTranslation';

function ExpandAllHeader({ allExpanded, onToggle, width = '40px' }) {
  const { t } = useTranslation();
  return (
    <th
      style={{ width, textAlign: 'center', cursor: 'pointer' }}
      onClick={onToggle}
      title={allExpanded ? t('common.clickToCollapseAll') : t('common.clickToExpandAll')}
    >
      <i className={`bi bi-chevron-${allExpanded ? 'up' : 'down'}-circle`}></i>
    </th>
  );
}

export default ExpandAllHeader;
